// components/auth/Login.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthSimple } from '../../hooks/useAuth';
import { AuthService } from '../../services/authService';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  const { login, loading } = useAuthSimple();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      await login(email, password);
      
      // Após login, verificar o tipo de usuário para redirecionar
      const user = AuthService.getCurrentUser();
      if (user?.type === 'master') {
        // Master vai para cadastro de empresa/grupo
        navigate('/cadastro', { replace: true });
      } else {
        // Usuários normais vão para o dashboard
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro no login');
    }
  };



  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F4EFFA' }}>
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center mb-4">
            <img src="/AixaCorretor.svg" alt="AIXA" className="h-16" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold" style={{ color: '#3d2b56' }}>
            AIXA Dashboard
          </h2>
          <p className="mt-2 text-center text-xs" style={{ color: '#9E9E9E' }}>
            Faça login em sua conta
          </p>
        </div>

        <form className="mt-8 space-y-3" onSubmit={handleLogin}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <input
                id="email"
                name="email"
                type="text"
                autoComplete="username"
                required
                className="relative block w-full px-3 py-2 border rounded-t-md focus:outline-none focus:z-10 sm:text-xs"
                style={{ borderColor: '#C3B4DE', backgroundColor: '#FFFFFF', color: '#121212' }}
                onFocus={(e) => e.target.style.borderColor = '#7A61B2'}
                placeholder="Email ou usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="relative block w-full px-3 py-2 border rounded-b-md focus:outline-none focus:z-10 sm:text-xs"
                style={{ borderColor: '#C3B4DE', backgroundColor: '#FFFFFF', color: '#121212' }}
                onFocus={(e) => e.target.style.borderColor = '#7A61B2'}
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="text-xs text-red-700">{error}</div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-xs font-medium rounded-md text-white hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};